import IconArrow from "../icon/IconArrow";
import { IconButtonContainer, IconButtonProps } from "./IconButtonContainer";

interface IconButtonArrowProps extends IconButtonProps {
    direction?: "up" | "down"
}

export default function IconButtonArrow(props: IconButtonArrowProps) {
    return <IconButtonContainer {...props}>
        <IconArrow direction={props.direction} />
    </IconButtonContainer>

}